/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import AqaStatement from '../model/AqaStatement';

/**
* AQABillingController service.
* @module api/AQABillingControllerApi
* @version v0
*/
export default class AQABillingControllerApi {

    /**
    * Constructs a new AQABillingControllerApi. 
    * @alias module:api/AQABillingControllerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the getCurrentStatement operation.
     * @callback moduleapi/AQABillingControllerApi~getCurrentStatementCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaStatement{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets A statemnent for the account and shows an invoice as if it was raised today. Only for admins
     * @param {module:api/AQABillingControllerApi~getCurrentStatementCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getCurrentStatement(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaStatement;

      return this.apiClient.callApi(
        '/api/v1/billing/statement', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}